import React from 'react';
import { getRecipeField, getEnumTranslation, getRecipeTypeIcon, formatDate } from './utils';
import Tag from './Tag';

const RecipeCard = ({ recipe, lang }) => (
    <div className="recipe-card">
        <img src={recipe.image} alt={getRecipeField(recipe, 'title', lang)} className="recipe-card-img" />
        <div className="recipe-card-content">
            <h3>{getRecipeField(recipe, 'title', lang)}</h3>
            <p>{getRecipeField(recipe, 'description', lang)}</p>
            <div className="recipe-card-tags">
                {recipe.author && <Tag>{getEnumTranslation(recipe.author, lang)}</Tag>}
                {recipe.date && <Tag>{formatDate(recipe.date, lang)}</Tag>}
                {recipe.country && <Tag>{getEnumTranslation(recipe.country, lang)}</Tag>}
                {recipe.cuisine && <Tag>{getEnumTranslation(recipe.cuisine, lang)}</Tag>}
                {recipe.type && <Tag>{getRecipeTypeIcon(recipe.type)} {getEnumTranslation(recipe.type, lang)}</Tag>}
            </div>
        </div>
    </div>
);

export default RecipeCard; 